export const FieldSkeleton = () => (
  <div className="col-span-full flex flex-col gap-2">
    <div className="h-4 w-full animate-pulse rounded-lg bg-grey-120" />
    <div className="h-10 w-full animate-pulse rounded-lg bg-grey-120" />
  </div>
)
